<template>
  <div class="passcode-input-area">
    <div class="input-row" v-for="(row, index) in items" :key="row.id">
      <div class="number-circle" v-for="item in row" :key="item">
        <div v-if="item != '#'">
          <button @click="pushedNumber(item)">
            {{ item }}
          </button>
        </div>
      </div>
      <div class="number-circle" v-if="index == 3">
        <button v-if="isFulfill" @click="pushedOK()">
          <p>OK</p>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";

export default {
  name: "CodeInputButtons",
  props: {
    code: {
      type: String,
    },
    isFulfill: {
      type: Boolean,
    },
  },
  setup(props, context) {
    const items = ref([
      ["1", "2", "3"],
      ["4", "5", "6"],
      ["7", "8", "9"],
      ["#", "0"],
    ]);

    onMounted(async () => {
      // 画面制御
      let elements = document.getElementsByTagName("input");
      elements.forEach(function (element) {
        element.addEventListener(
          "touchend",
          (event) => {
            event.preventDefault();
          },
          false
        );
      });
    });

    // 押された数字を文字列(code)に末尾に追加する親コンポーネントを発火
    const pushedNumber = (number) => {
      if (props.code.length < 8) {
        context.emit("parentMethod1", number);
      }
    };

    // 子コンポーネントでOKを押されたら祖父コンポーネントの持つメソッドを発火
    const pushedOK = () => {
      context.emit("parentMethod2");
    };

    return {
      items,
      pushedNumber,
      pushedOK,
    };
  },
};
</script>

<style lang="scss" scoped>
input {
  background-color: transparent;
  border-style: none;
}
.passcode__wrapper {
  width: 83vw;
  max-width: 272px;
  margin: auto;
  color: $white;
  top: var(--navigation-height);
  position: relative;
  .passcode__wrapper--title {
    text-align: center;
    padding-top: 42px;
    font-size: 14px;
  }

  .passcode-input-area {
    .input-row {
      margin-bottom: 3vh;
      width: 100%;
      .number-circle {
        display: inline-block;
        margin-right: 14%;
        width: 24%;
        button {
          border: 1px solid white;
          font-size: 24px;
          width: 64px;
          height: 64px;
          border-radius: 50%;
          background: transparent;
          color: white;
          padding: 0;
        }
        button:active {
          background: rgba(255, 255, 255, 1);
          color: #9895d4;
        }
      }
      .number-circle:last-child {
        margin-right: 0px;
      }
    }
  }
}
</style>
